<template>
  <div class="fixed-container">
    <div style="width: 100%">
      <ItemButton
        label="利用する"
        :is-disabled="false"
        action-type="submit"
        @clicked="onClickUsingButton"
      />
      <ItemButton
        label="予約取り消し"
        :is-disabled="false"
        action-type="submit"
        @clicked="onClickCancelButton"
      />
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" />

  <!-- 予約有効期限切れ時のダイアログ -->
  <DialogReservationExpired ref="DialogReservationExpired" />

  <!-- 予約取り消しの確認ダイアログ -->
  <DialogConfirmReservationCancel ref="DialogConfirmReservationCancel" />
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

import dbsService from "@/services/dbs";

export default {
  name: "DbsMyBookingBottomButtons",
  setup() {
    const router = useRouter();

    const DialogLoading = ref(null);
    const DialogReservationExpired = ref(null);
    const DialogConfirmReservationCancel = ref(null);

    const onClickUsingButton = async () => {
      try {
        DialogLoading.value.openDialog();

        // 予約期限切れの場合
        if (await dbsService.isExpiredReservation()) {
          DialogLoading.value.closeDialog();
          DialogReservationExpired.value.openDialog();
        } else {
          DialogLoading.value.closeDialog();
          router.push({
            name: "DbsUnlocking",
          });
        }
      } catch (e) {
        DialogLoading.value.closeDialog();
        console.log(
          "Error in DbsMyBookingBottomButtons.onClickUsingButton()",
          e
        );
      }
    };

    const onClickCancelButton = async () => {
      try {
        DialogLoading.value.openDialog();

        // 予約期限切れの場合
        if (await dbsService.isExpiredReservation()) {
          DialogLoading.value.closeDialog();
          DialogReservationExpired.value.openDialog();
        } else {
          DialogLoading.value.closeDialog();
          DialogConfirmReservationCancel.value.openDialog();
        }
      } catch (e) {
        DialogLoading.value.closeDialog();
        console.log(
          "Error in DbsMyBookingBottomButtons.onClickCancelButton()",
          e
        );
      }
    };

    return {
      onClickUsingButton,
      onClickCancelButton,
      DialogLoading,
      DialogReservationExpired,
      DialogConfirmReservationCancel,
    };
  },
};
</script>
<style scoped>
.fixed-container {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffb206;
  padding: 15px 15px 20px 15px;
}
.fixed-container button {
  width: calc(100% - 30px);
  height: 46px;
  border: none;
  border-radius: 30px;
  background-color: #ffffff;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}
</style>
